import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getSessions, deleteSession, type Session } from "../api/client";
import { StatusBadge } from "../components/StatusBadge";

export function SessionList() {
  const navigate = useNavigate();
  const [sessions, setSessions] = useState<Session[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    getSessions()
      .then(setSessions)
      .catch((e) => setError((e as Error).message))
      .finally(() => setLoading(false));
  }, []);

  const handleDelete = (s: Session, e: React.MouseEvent) => {
    e.stopPropagation();
    if (!confirm(`Eliminare la sessione per ${s.recipient_name}?`)) return;
    deleteSession(s.id)
      .then(() => setSessions((prev) => prev.filter((x) => x.id !== s.id)))
      .catch((err) => alert((err as Error).message));
  };

  const handleRetry = (s: Session, e: React.MouseEvent) => {
    e.stopPropagation();
    navigate(`/upload?retry=${s.id}`);
  };

  if (loading) {
    return (
      <div style={{ display: "flex", justifyContent: "center", padding: "var(--space-8)" }}>
        <span className="spinner spinner-lg" />
      </div>
    );
  }

  return (
    <div>
      <h1 className="page-title">Sessioni di Firma</h1>
      <p className="page-subtitle">Monitora lo stato di tutte le sessioni create.</p>

      {error && (
        <div className="toast toast-error" style={{ marginBottom: "var(--space-3)" }}>
          <span className="material-symbols-outlined">error</span>
          {error}
        </div>
      )}

      {sessions.length === 0 ? (
        <div className="card" style={{ textAlign: "center", padding: "var(--space-8)" }}>
          <span className="material-symbols-outlined" style={{ fontSize: 48, color: "var(--indaco-gray-400)" }}>
            folder_open
          </span>
          <p style={{ color: "var(--indaco-gray-600)", marginTop: "var(--space-2)" }}>
            Nessuna sessione ancora. Carica un documento per iniziare.
          </p>
        </div>
      ) : (
        <div className="card" style={{ padding: 0, overflow: "hidden" }}>
          <div className="table-container">
            <table>
              <thead>
                <tr>
                  <th>Destinatario</th>
                  <th>Telefono</th>
                  <th>Stato</th>
                  <th>Azienda</th>
                  <th>Creata</th>
                  <th style={{ textAlign: "right" }}>Azioni</th>
                </tr>
              </thead>
              <tbody>
                {sessions.map((s) => (
                  <tr key={s.id} onClick={() => navigate(`/sessions/${s.id}`)}>
                    <td style={{ fontWeight: 500 }}>{s.recipient_name}</td>
                    <td>{s.recipient_phone}</td>
                    <td><StatusBadge status={s.status} /></td>
                    <td>{s.company_name || "—"}</td>
                    <td style={{ fontSize: "var(--font-size-sm)", color: "var(--indaco-gray-600)" }}>
                      {new Date(s.created_at).toLocaleString("it-IT", {
                        day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit",
                      })}
                    </td>
                    <td style={{ textAlign: "right", whiteSpace: "nowrap" }}>
                      {s.status !== "signed" && (
                        <button
                          className="btn btn-ghost"
                          style={{ padding: "4px 8px", minWidth: 0, color: "var(--indaco-primary)", fontSize: "var(--font-size-xs)" }}
                          title="Riavvia sessione"
                          onClick={(e) => handleRetry(s, e)}
                        >
                          <span className="material-symbols-outlined" style={{ fontSize: 18 }}>refresh</span>
                        </button>
                      )}
                      <button
                        className="btn btn-ghost"
                        style={{ padding: "4px 8px", minWidth: 0, color: "var(--indaco-error, #dc2626)", fontSize: "var(--font-size-xs)" }}
                        title="Elimina sessione"
                        onClick={(e) => handleDelete(s, e)}
                      >
                        <span className="material-symbols-outlined" style={{ fontSize: 18 }}>delete</span>
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
}
